
import { motion } from 'framer-motion';

export default function GalleryCTA() {
  return (
    <section className="relative py-16 sm:py-24 lg:py-32 bg-[#050505] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2025de98705a411570128e52739adb90.jpg"
          alt=""
          className="w-full h-full object-cover object-top opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/85 to-[#050505]"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <span
            className="text-[#00E5FF] text-xs sm:text-sm tracking-[0.3em] uppercase font-semibold"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Twój Projekt
          </span>

          <h2
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 sm:mt-6 mb-4 sm:mb-8 leading-tight"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Gotowy na{' '}
            <span className="text-[#00E5FF]">Realizację?</span>
          </h2>

          <p
            className="text-sm sm:text-base lg:text-lg text-[#C0C7CF] mb-8 sm:mb-12 max-w-2xl mx-auto leading-relaxed px-2"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Każdy projekt zaczynamy od dokładnej analizy potrzeb. Skontaktuj się z nami
            i dołącz do grona naszych zadowolonych klientów przemysłowych.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4 sm:px-0">
            <a
              href="/#kontakt"
              className="w-full sm:w-auto inline-block px-8 sm:px-12 py-4 sm:py-5 bg-[#00E5FF] text-[#050505] font-bold text-xs sm:text-sm hover:bg-white transition-all duration-300 whitespace-nowrap cursor-pointer shadow-[0_0_30px_rgba(0,229,255,0.2)] text-center"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              Rozpocznij projekt
            </a>
            <a
              href="/uslugi"
              className="w-full sm:w-auto inline-block px-8 sm:px-12 py-4 sm:py-5 border border-[#C0C7CF]/30 text-[#C0C7CF] font-bold text-xs sm:text-sm hover:border-[#00E5FF] hover:text-[#00E5FF] transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              Poznaj usługi
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
